import { Grid } from '@mui/material';
import Form from 'mobx-react-form';
import { observer } from 'mobx-react-lite';

import NumericInput from 'components/shared/inputs/NumericInput';
import { showSection } from '../constants';

const MAX_UNITS_NUMBER = 95;

type UnitCountSectionProps = {
  form: Form;
  fieldName: string;
  section: string;
  fieldLabel: string;
  propertyType: string;
};

const UnitCountSection = observer(({ form, section, fieldName, fieldLabel, propertyType }: UnitCountSectionProps) => {
  const shouldDisable = !(!section || showSection(section, propertyType));

  return (
    <Grid item xs={12} sx={{ display: 'flex' }}>
      <NumericInput
        {...form.$(fieldName).bind()}
        size="small"
        margin="normal"
        label={fieldLabel}
        fullWidth
        disabled={shouldDisable}
        decimalScale={0}
        allowNegative={false}
        thousandSeparator
        helperText={`Max ${MAX_UNITS_NUMBER} units`}
      />
    </Grid>
  );
});

export { UnitCountSection };
